<template>
    <div>
        <div
            class="border bg-white dark:bg-gray-700 rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
        >
            <p class="text-gray-700 dark:text-gray-200 mb-4">Conversions</p>
            <multi-reference
                create-text="Create new conversion and link conversion to this page"
                link-text="Link existing conversions"
                :language="language"
                v-model="conversions"
                model-data="Conversion"
                :creatable="false"
                :linkable="false"
                :deletable="true"
                :editable="true"
                :numbered="true"
                :force-delete="true"
                :highlight="highlight"
                @input="$emit('input', conversions)"
                @deleted="$emit('deleted')"
            />
        </div>
    </div>
</template>
<script>
export default {
    name: "RankingConversions",
    props: {
        value: {
            type: Array,
            required: true,
        },
        language: {
            type: Object,
            required: true,
        },
        highlight: Array,
    },
    data() {
        return {
            conversions: this.value,
        };
    },
};
</script>
